import { React, useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import elliesImage from "./assets/Ellipse.png";
import mainLogo from "./assets/logo.svg";
import { useNavigate } from "react-router-dom";
import HTTP_BASE_URL from "../constants/HttpConstants";
import mobLogo from "./assets/Kancroo-logo.svg";
import { MdLogout } from "react-icons/md";
import { HiHome } from "react-icons/hi2";

const Header = () => {
  const navigate = useNavigate();
  const [logout, setLogout] = useState(false);
  const [showNavbar, setShowNavbar] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const customertoken = localStorage.getItem("customertoken");
  const customerName = localStorage.getItem("customerName");
  const customerMobile = localStorage.getItem("customerMobile");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleShowNavbar = (event) => {
    event.stopPropagation(); // Prevents event bubbling

    if (!showNavbar) {
      setShowNavbar(true);
      setIsChanged(true);
      document.body.style.overflow = "hidden"; // Prevent scrolling when menu is open
    }
  };
  const handleCloseNavbar = () => {
    setShowNavbar(false);
    setIsChanged(false);
    document.body.style.overflow = "unset"; // Restore scrolling when menu is closed
  };
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        handleCloseNavbar();
      }
    };

    if (showNavbar) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showNavbar]);

  const handleLogout = async () => {
    // console.log('logout success')
    const fullData = new FormData();
    fullData.append("log_token", customertoken);
    try {
      const response = await fetch(HTTP_BASE_URL + "customerlogout", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
        },
        body: fullData,
      });
      const result = await response.json();
      if (result?.code === 0 || result?.code === 1) {
        // Step 1: Clear storage
        localStorage.clear(); // or sessionStorage.clear();
        // Step 2: Redirect to login or all-booking page
        navigate("/", { replace: true });
        // Step 3: Prevent going back to the previous page
        window.history.pushState(null, "", window.location.href);
        window.onpopstate = () => {
          window.history.pushState(null, "", window.location.href);
        };
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="container-fluid bg-white p-0 relative">
        <a href="/all-booking" className="navbar-brand d-none d-lg-block">
          <img
            className="logo-image success-logo"
            src={mainLogo}
            alt="Represents our brand's identity and commitment to quality."
            width={166}
            height={166}
            loading="eager"
          />
        </a>
        <div className={`container mob-header ${scrolled ? "scrolled" : ""}`}>
          <nav className="navbar">
            <div className="container-fluid">
              <div className="navbar-logo d-lg-none">
                <a href="/all-booking">
                  <img
                    className={`main-mob-logo img-fluid logo ${
                      scrolled ? "small" : ""
                    }`}
                    src={mobLogo}
                    width={82}
                    height={85}
                    loading="eager"
                    alt="Logo for Kancaroo Trusted Car Carriers, featuring a sleek design with a car silhouette and the company name."
                  />
                </a>
              </div>

              <div className="d-lg-none relative" ref={menuRef}>
                <div
                  className={`menu-icon ${isChanged ? "change" : ""}`}
                  onClick={handleShowNavbar}
                >
                  <div className="bar1"></div>
                  <div className="bar2"></div>
                  <div className="bar3"></div>
                </div>
                <div
                  className={`nav-elements-mob ${showNavbar ? "active" : ""}`}
                >
                  <ul className="d-lg-none">
                    <div className="row m-0 pb-4">
                      <div>
                        <img
                          alt="navbar-toggler-icon"
                          src={elliesImage}
                          width={35}
                          height={35}
                          loading="eager"
                          style={{ marginRight: "10px" }}
                        />
                      </div>
                      <div className="align-self-center">
                        <p style={{ lineHeight: "15px" }}>
                          {customerName || ""}
                        </p>
                        <span
                          style={{
                            fontSize: "12px",
                            lineHeight: "10px",
                            color: "#D7000C",
                            fontWeight: "400",
                          }}
                        >
                          {customerMobile || ""}
                        </span>
                      </div>
                    </div>
                    <div className="pt-2">
                      <li>
                        <NavLink to="/all-booking">
                          <HiHome />
                          All Booking
                        </NavLink>
                      </li>
                      <li>
                        <p onClick={handleLogout}>
                          <MdLogout />
                          Logout
                        </p>
                      </li>
                    </div>
                  </ul>
                </div>
                {/* Background Overlay (Clicking it will close the navbar) */}
                {showNavbar && (
                  <div className="overlay" onClick={handleCloseNavbar}></div>
                )}
              </div>

              {/* desktop view */}

              <div className="d-none d-lg-block">
                <div
                  className={`menu-icon ${isChanged ? "change" : ""}`}
                  //   onClick={handleShowNavbar}
                >
                  <div className="bar1"></div>
                  <div className="bar2"></div>
                  <div className="bar3"></div>
                </div>
                <div className={`nav-elements  ${showNavbar && "active"}`}>
                  <ul className="d-none d-lg-block mb-0">
                    <li>
                      <NavLink to="/all-booking">All Booking</NavLink>
                    </li>
                    <div className="realative">
                      <div
                        className="select-customer"
                        onClick={() => setLogout((prev) => !prev)}
                      >
                        <img
                          alt="navbar-toggler-icon"
                          src={elliesImage}
                          width={30}
                          height={30}
                          loading="eager"
                          style={{ marginRight: "5px" }}
                        />
                        {customerName || ""}
                      </div>
                      {logout && (
                        <div className="logoutBtn">
                          {/* <button >Profile Settings</button> */}
                          <button onClick={handleLogout}>
                            <MdLogout />
                            Logout
                          </button>
                        </div>
                      )}
                    </div>
                  </ul>
                </div>
                {showNavbar && <div className="overlay"></div>}
              </div>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Header;
